import React from 'react';

import { PopUp, Dialog, DialogHeader, DialogContent } from '@ergeon/core-components';

import { ModalHandler } from '../ModalController';
import { useModalClose } from '../../hooks/useModalClose';

import { SHORTCUTS_DATA } from './shortcuts-data';
import { KeyboardKey } from './KeyboardKey';

interface KeyboardShortcutsHelpModalProps {
  modal: ModalHandler;
}

const KeyboardShortcutsHelpModal: React.FC<KeyboardShortcutsHelpModalProps> = ({ modal }) => {
  const closeModal = useModalClose(modal);

  return (
    <PopUp isVisible={modal.visible} maxWidth="xsmall" onChangeVisible={closeModal}>
      <Dialog isVisible={modal.visible}>
        <DialogHeader onDismiss={closeModal} title="Keyboard Shortcuts" />
        <DialogContent>
          <div className="flex flex-col gap-4">
            {SHORTCUTS_DATA.map((categoryData) => (
              <div
                className="flex flex-col gap-3 pt-4 border-gray-300 dark:border-gray-700 border-t"
                key={categoryData.category}>
                <h3 className="text-gray-900 dark:text-gray-100 heading-6">{categoryData.category}</h3>
                <div className="flex flex-col gap-2">
                  {categoryData.shortcuts.map((shortcut, index) => (
                    <div className="flex justify-between items-center gap-2" key={index}>
                      <span className="text-gray-700 dark:text-gray-300 paragraph-3">{shortcut.description}</span>
                      <KeyboardKey keys={shortcut.keys} />
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="flex justify-center pt-4 border-gray-300 dark:border-gray-700 border-t">
              <p className="flex justify-center items-center gap-1 text-gray-500 paragraph-2">
                Press
                <KeyboardKey keys={['Shift', '?']} />
                anytime to show this dialog
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </PopUp>
  );
};

export default KeyboardShortcutsHelpModal;
